import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { chatMessageCount } from 'redux/actions/myClaims';
import { useHistory } from 'react-router-dom';
const ChatboxComponent = ({ item }) => {

  let history = useHistory();
  const dispatch = useDispatch();
  const [chatCount, setChatCount] = useState(0)

  useEffect(() => {

    fetchApiForChatMessageCount()

  }, [])



  const fetchApiForChatMessageCount = async () => {

    const token = localStorage.getItem('token');
    let locationId = localStorage.getItem("locationID")

    let buyerLocationId, sellerLocationID

    if (item.order?.buyerInfo?.locationsId) {
      let buyerLocationIdTemp = item.order?.buyerInfo?.locationsId?.filter(val => val == locationId)
      if (buyerLocationIdTemp?.length > 0) buyerLocationId = item.order?.buyerInfo?.locationsId?.toString()
    }
    else {
      if (item.order?.buyerInfo?.locationId === locationId) buyerLocationId = item.order?.buyerInfo?.locationId
    }

    if (item.order?.sellerInfo?.locationsId) {
      let sellerLocationIdTemp = item.order?.sellerInfo?.locationsId?.filter(val => val == locationId)
      if (sellerLocationIdTemp?.length > 0) sellerLocationID = item.order?.sellerInfo?.locationsId?.toString()
    }
    else {
      if (item.order?.sellerInfo?.locationId === locationId) sellerLocationID = item.order?.sellerInfo?.locationId
    }

    let data = {
      userAuth: buyerLocationId ? buyerLocationId : sellerLocationID ? sellerLocationID : '',
      userType: buyerLocationId ? 'BUYER' : sellerLocationID ? 'SELLER' : '',

    }

    let response = await dispatch(chatMessageCount(data, token));

    if (response && response.status === 'SUCCESS') {

      if (response.payload?.length) {
        let filterchatmessagecount = response.payload?.find((value) => {
          return value.orderId == item.orderId
        })
        setChatCount(filterchatmessagecount?.unreadMsgCount)
      }
    } else {
      if (response.statusCode === 401) {
        history.push('/sign-in')
        window.location.reload(false);
      }
    }
  }

  return (
    <>
      {chatCount > 0 &&
        <div style={{ height: '26px', width: '26px', borderRadius: '13px', background: '#27911b', top: '-20px', position: 'relative', left: '', fontSize: "", textAlign: "center" }}>
          <span title={``} style={{ position: 'relative', left: '', color: 'white', top: '4px' }} onClick={() => {
            setChatCount(0)
          }}>
            {chatCount}
          </span>
        </div>
      }
    </>
  )
}

export default ChatboxComponent
